// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__8aSB7","center":"Footer_center__f7GuJ"};